
 var bestseller = new Swiper('.bestseller.swiper-container', {
    slidesPerView: 1.2, 
    spaceBetween: 15, 
    loopAdditionalSlides : 1,
 pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
// slidesOffsetAfter :300,
    breakpoints: { //반응형 조건 속성
      640: { //640 이상일 경우
        slidesPerView: 1.2, 
      },
      1024: {
        slidesPerView: 3,
        allowTouchMove: false
      },
      1400: {
        slidesPerView: 4,
       allowTouchMove: false
      },
    }
});